// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
._material-design-icon_4S2t9 {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
._formBoxItem_TcR5F {
  --nc-form-box-item-border-width: 1px;
  --nc-form-box-item-min-height: 40px;
  --form-element-label-offset: calc(var(--border-radius-element) + var(--default-grid-baseline));
  --form-element-label-padding: calc(var(--form-element-label-offset) - var(--nc-form-box-item-border-width));
  --color-primary-element-extra-light: hsl(from var(--color-primary-element-light) h s calc(l * 1.045));
  --color-primary-element-extra-light-hover: hsl(from var(--color-primary-element-light-hover) h s calc(l * 1.045));
  position: relative;
  display: flex;
  align-items: center;
  gap: calc(2 * var(--default-grid-baseline));
  min-height: var(--nc-form-box-item-min-height);
  padding-inline: var(--form-element-label-padding);
  border: 1px solid var(--color-primary-element-extra-light-hover);
  border-bottom-width: 2px;
  border-radius: var(--border-radius-element);
  background-color: var(--color-primary-element-extra-light);
  color: var(--color-main-text);
  transition-property: color, border-color, background-color;
  transition-duration: var(--animation-quick);
  transition-timing-function: linear;
  -webkit-user-select: none;
  user-select: none;
  cursor: pointer;
}
._formBoxItem_TcR5F * {
  cursor: inherit;
}
._formBoxItem_TcR5F:has(:disabled) {
  cursor: default;
  opacity: 0.5;
}
._formBoxItem_TcR5F:hover:not(:has(:disabled)) {
  color: var(--color-primary-element-light-text);
  background-color: var(--color-primary-element-extra-light-hover);
}
._formBoxItem_TcR5F:has(:focus-visible) {
  outline: 2px solid var(--color-main-text);
  box-shadow: 0 0 0 4px var(--color-main-background);
}
._formBoxItem_TcR5F._formBoxItem_legacy_z5RqX {
  --nc-form-box-item-border-width: 0px;
  border: none;
}
._formBoxItem_TcR5F._formBoxItem_inverted_MA48p ._formBoxItem__element_bHzJ1 {
  color: var(--color-text-maxcontrast);
}
._formBoxItem_TcR5F._formBoxItem_inverted_MA48p ._formBoxItem__description_pBmbK {
  color: inherit;
}
._formBoxItem__content_SawhG {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding-block: calc(2 * var(--default-grid-baseline));
  overflow-wrap: anywhere;
}
._formBoxItem__element_bHzJ1::after {
  content: "";
  position: absolute;
  inset: 0;
}
._formBoxItem__description_pBmbK {
  color: var(--color-text-maxcontrast);
}
._formBoxItem__icon_4AJit {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcFormBoxItem-BdFKDYqL.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,oCAAoC;EACpC,mCAAmC;EACnC,8FAA8F;EAC9F,2GAA2G;EAC3G,qGAAqG;EACrG,iHAAiH;EACjH,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,2CAA2C;EAC3C,8CAA8C;EAC9C,iDAAiD;EACjD,gEAAgE;EAChE,wBAAwB;EACxB,2CAA2C;EAC3C,0DAA0D;EAC1D,6BAA6B;EAC7B,0DAA0D;EAC1D,2CAA2C;EAC3C,kCAAkC;EAClC,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,YAAY;AACd;AACA;EACE,8CAA8C;EAC9C,gEAAgE;AAClE;AACA;EACE,yCAAyC;EACzC,kDAAkD;AACpD;AACA;EACE,oCAAoC;EACpC,YAAY;AACd;AACA;EACE,oCAAoC;AACtC;AACA;EACE,cAAc;AAChB;AACA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,qDAAqD;EACrD,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;AACV;AACA;EACE,oCAAoC;AACtC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B","sourcesContent":["/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n._material-design-icon_4S2t9 {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n._formBoxItem_TcR5F {\n  --nc-form-box-item-border-width: 1px;\n  --nc-form-box-item-min-height: 40px;\n  --form-element-label-offset: calc(var(--border-radius-element) + var(--default-grid-baseline));\n  --form-element-label-padding: calc(var(--form-element-label-offset) - var(--nc-form-box-item-border-width));\n  --color-primary-element-extra-light: hsl(from var(--color-primary-element-light) h s calc(l * 1.045));\n  --color-primary-element-extra-light-hover: hsl(from var(--color-primary-element-light-hover) h s calc(l * 1.045));\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: calc(2 * var(--default-grid-baseline));\n  min-height: var(--nc-form-box-item-min-height);\n  padding-inline: var(--form-element-label-padding);\n  border: 1px solid var(--color-primary-element-extra-light-hover);\n  border-bottom-width: 2px;\n  border-radius: var(--border-radius-element);\n  background-color: var(--color-primary-element-extra-light);\n  color: var(--color-main-text);\n  transition-property: color, border-color, background-color;\n  transition-duration: var(--animation-quick);\n  transition-timing-function: linear;\n  -webkit-user-select: none;\n  user-select: none;\n  cursor: pointer;\n}\n._formBoxItem_TcR5F * {\n  cursor: inherit;\n}\n._formBoxItem_TcR5F:has(:disabled) {\n  cursor: default;\n  opacity: 0.5;\n}\n._formBoxItem_TcR5F:hover:not(:has(:disabled)) {\n  color: var(--color-primary-element-light-text);\n  background-color: var(--color-primary-element-extra-light-hover);\n}\n._formBoxItem_TcR5F:has(:focus-visible) {\n  outline: 2px solid var(--color-main-text);\n  box-shadow: 0 0 0 4px var(--color-main-background);\n}\n._formBoxItem_TcR5F._formBoxItem_legacy_z5RqX {\n  --nc-form-box-item-border-width: 0px;\n  border: none;\n}\n._formBoxItem_TcR5F._formBoxItem_inverted_MA48p ._formBoxItem__element_bHzJ1 {\n  color: var(--color-text-maxcontrast);\n}\n._formBoxItem_TcR5F._formBoxItem_inverted_MA48p ._formBoxItem__description_pBmbK {\n  color: inherit;\n}\n._formBoxItem__content_SawhG {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  padding-block: calc(2 * var(--default-grid-baseline));\n  overflow-wrap: anywhere;\n}\n._formBoxItem__element_bHzJ1::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n}\n._formBoxItem__description_pBmbK {\n  color: var(--color-text-maxcontrast);\n}\n._formBoxItem__icon_4AJit {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
